<div class="flex flex-row justify-between items-center solution-card m-4" [ngClass]="{'cursor-pointer': !loader}"
     (click)="!loader ? goToBlueprintSummary() : ''" *ngIf="serviceCardInfo">
  <div class="flex flex-row sandbox">
    <img src="/assets/icons/bank.svg" class="w-34 h-36 mr-20">
    <div class="mat-subtitle-2 mb-0 service-name word-break-word">{{ serviceCardInfo?.blueprint?.name ? serviceCardInfo?.blueprint?.name : serviceCardInfo?.name }}</div>
  </div>
  <div class="flex flex-row status">
    <div *ngIf="serviceCardInfo.status">
      <div [ngClass]="statusInfo[serviceCardInfo.status].colorClass" class="traffic-light icon-container mr-20">
        <mat-icon class="items-center white-fg icon-sm"
          [svgIcon]="statusInfo[serviceCardInfo.status].icon">
        </mat-icon>
      </div>
    </div>
    <div *ngIf="!loader; else skeletonLoader" class="mat-subtitle-2 fw-600 mb-0 word-break-word">
      {{(serviceCardInfo.status ? 'SERVICE_STATUS.' + serviceCardInfo.status : 'INSTANCE_STATUS.NA') | transloco}}
    </div>
  </div>
  <div class="flex flex-row justify-between items-center expiry">
    <div *ngIf="!loader; else skeletonLoader" class="mat-subtitle-2 fw-500 ml-16 mr-20 mb-0">{{trialStatus}}</div>
    <div class="flex flex-row items-center">
      <!-- <mat-icon svgIcon="chat_bubble_outline" [ngClass]="{'disabled': !serviceCardInfo?.service?.punchline}" class="icon-md mr-18" [matTooltip]="serviceCardInfo?.service?.punchline"
        matTooltipPosition="above" matTooltipClass="mat-tooltip tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon>
      <mat-icon svgIcon="place" [ngClass]="{'disabled': !region}" class="icon-md mr-18" [matTooltip]="region"
        matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon>
        <mat-icon svgIcon="token" [ngClass]="{'disabled': !releaseVersion}" class="icon-md mr-18" [matTooltip]="isAMR? ('Release ' + releaseVersion + ' | AMR'): ('Release ' + releaseVersion)"
        matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon>
      <mat-icon svgIcon="layers" [ngClass]="{'disabled': !capabilities}" class="icon-md ml-auto mr-18" matTooltip="{{capabilities}} Capabilities"
        matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon>
      <mat-icon svgIcon="pages" [ngClass]="{'disabled': !serviceCardInfo?.serviceDefinitionVersion}" class="icon-md ml-auto mr-18" [matTooltip]="'Version ' + serviceCardInfo?.serviceDefinitionVersion"
        matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon> -->
    </div>
  </div>
  <ng-template #skeletonLoader>
    <div class="pl-6 skeleton-loader">
      <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
    </div>
  </ng-template>
</div>
